<template>
  <el-scrollbar>
    <div class="view-modal window-scorll">
      <div class="card-carousel-collapse">
        <el-row :gutter="20" class="mb-20">
            <el-col :span="10">
                <el-card class="box-card" style="width:100%;">
                  <div slot="header" class="clearfix">
                    <span>卡片名称</span>
                    <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>
                  </div>
                  <div v-for="o in 4" :key="o" class="text item">
                    {{'列表内容 ' + o }}
                  </div>
                </el-card>
            </el-col>
            <el-col :span="10">
                <el-card class="box-card" style="width:100%;">
                  <div v-for="o in 4" :key="o" class="text item">
                    {{'列表内容 ' + o }}
                  </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row class="mb-20">
          <el-col style="width:420px;" v-for="(o, index) in 2" :key="o" :offset="index > 0 ? 2 : 0">
            <el-card :body-style="{ padding: '0px' }">
              <img src="../../assets/1.jpg" height="236" width="420" style="" class="image">
              <div style="padding: 14px;">
                <span>好吃的汉堡</span>
                <div class="bottom clearfix">
                  <time class="time">{{ currentDate | formatDateD }}</time>
                  <el-button type="text" class="button">操作按钮</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="12" class="mb-20">
          <el-col :span="8">
            <el-card shadow="always">
              总是显示
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="hover">
              鼠标悬浮时显示
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="never">
              从不显示
            </el-card>
          </el-col>
        </el-row>
        <hr>
        <el-row class="mb-20">
            <div class="block" style="width:30%;float:left;margin-right:5%">
              <span class="demonstration">默认 Hover 指示器触发</span>
              <el-carousel height="150px" indicator-position="outside">
                <el-carousel-item v-for="item in 4" :key="item">
                  <h3>{{ item }}</h3>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="block" style="width:30%;float:left;margin-right:5%">
              <span class="demonstration">Click 指示器触发</span>
              <el-carousel trigger="click" height="150px" arrow="always">
                <el-carousel-item v-for="item in 4" :key="item">
                  <h3>{{ item }}</h3>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="block" style="width:30%;float:left;">
                <el-carousel :interval="4000" type="card" height="150px">
                  <el-carousel-item v-for="item in 6" :key="item">
                    <h3>{{ item }}</h3>
                  </el-carousel-item>
                </el-carousel>
            </div>
        </el-row>
        <hr>
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item title="一致性 Consistency" name="1">
            <template slot="title">
              一致性 Consistency<i class="header-icon el-icon-info"></i>
            </template>
            <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
            <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
          </el-collapse-item>
          <el-collapse-item title="反馈 Feedback" name="2">
            <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
            <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
          </el-collapse-item>
          <el-collapse-item title="效率 Efficiency" name="3">
            <div>简化流程：设计简洁直观的操作流程；</div>
            <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
            <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
          </el-collapse-item>
          <el-collapse-item title="可控 Controllability" name="4">
            <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
            <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </el-scrollbar>
</template>
<script>
    export default {
      data() {
        return {
          currentDate: new Date().getTime(),
          activeNames: ['1'],//基础 都可开都可关
          activeName:'1',//手风琴模式
        };
      },
      methods: {
        handleChange(val) {
          console.log(val);
        }
      },
      created(){
          this.$parent.routerLoading();
      },
      mounted(){
        this.$parent.main_header_active = false;
      }
    }
</script>
<style scoped>
    .card-carousel-collapse::after{
        content: '';
        width: 0;
        height: 0;
        clear: both;
        display: block;
    }
    .text {
      font-size: 14px;
    }
  
    .item {
      margin-bottom: 18px;
    }
  
    .clearfix::before,
    .clearfix::after {
      display: table;
      content: "";
    }
    .clearfix::after {
      clear: both
    }
  
    .box-card {
      width: 480px;
    }

    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
      text-align: center;
    }
  
    .el-carousel__item:nth-child(2n) {
       background-color: #99a9bf;
    }
    
    .el-carousel__item:nth-child(2n+1) {
       background-color: #d3dce6;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/card-carousel-collapse.vue